module.exports = __webpack_public_path__ + "img/银柴胡.20c8ec91.jpg";